(function() { window.GUID_e76f9dd1_32d8_4a88_9f48_5952aafd622a = { getGuid: function() { return "e76f9dd1-32d8-4a88-9f48-5952aafd622a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CSRWeekDetailsPopup extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.chart = null;
                this.context = null;
                this.data = null;
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                console.log("CSRWeekDetailsPopup instantiated", this.controlId);
            }
            OnBindEvents() {
                console.log("CSRWeekDetailsPopup events bound");
            }
            OnControlRendered() {
                CS.Lag("CSRWeekDetailsPopupOnControlInstantiation", 100, () => {
                    this.$Control.css({
                        opacity: 1,
                    });
                });
                const $totalVariationElement = this.$Control.find(".CSRateDetailsSectionTotalVariation");
                if ($totalVariationElement.length) {
                    $totalVariationElement.css({
                        textAlign: "center",
                        fontSize: "0.8em",
                        fontStyle: "italic",
                        background: `linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%)`,
                        padding: "4px",
                        marginTop: "8px",
                    });
                    const $value = $totalVariationElement.find(".value");
                    const isPositive = $value.attr("data-positive") == "True";
                    if (isPositive) {
                        $value.css("color", "#00b300");
                    }
                    else {
                        $value.css("color", "rgb(255 80 80)");
                    }
                    $value.css({
                        fontWeight: "bold",
                        fontSize: "1.2em",
                    });
                    const $label = $totalVariationElement.find(".label");
                    $label.text(JSRess.TotalTCSRVariationDuringTheWeek);
                }
                const $title1 = $(`#CSRateDetailsSectionCSRTitle-${this.ControlId}`);
                if ($title1.length) {
                    $title1.text(JSRess.TCSRVariationByGame);
                }
                const $title2 = $(`#CSRateDetailsSectionCSRTitle2-${this.ControlId}`);
                if ($title2.length) {
                    $title2.text(JSRess.GameHistory);
                }
                const $dataInput = $(`#CSRWeekDetailsPopupWeekData-${this.ControlId}`);
                const $promotionPopupVersionInput = $(`#CSRWeekDetailsPopupWeekFallbackPromotionPopupVersion-${this.ControlId}`);
                if ($promotionPopupVersionInput.length) {
                    const promotionPopupVersion = $promotionPopupVersionInput.val();
                    const $promotionPopupParent = this.$Control.closest(".csr-details-promotion-popup-inner-content");
                    if ($promotionPopupParent.length && promotionPopupVersion) {
                        $promotionPopupParent.attr("data-version", promotionPopupVersion);
                    }
                }
                if (!$dataInput.length)
                    return;
                this.data = JSON.parse($dataInput.val());
                const canvas = document.getElementById(`CSRWeekDetailsPopupCanvas-${this.ControlId}`);
                if (!canvas)
                    return;
                if (!this.data || !this.data.datasets || !this.data.datasets.length) {
                    canvas.remove();
                    return;
                }
                // let allDataPointsHavePositiveValues = true;
                // let allDataPointsHaveNegativeValues = true;
                // let allDataPointsHaveNullValue = true;
                // if (this.data.datasets) {
                //   const lang = (CS.CommonData.Current.Language?.toLowerCase() ?? "en") as
                //     | "en"
                //     | "fr"
                //     | "es";
                //   moment.locale(lang);
                //   this.data.datasets.forEach((dataset) => {
                //     if (dataset.data) {
                //       dataset.data.forEach((dataPoint) => {
                //         dataPoint.displayStartDate = moment(dataPoint.startDate).format(
                //           `ll`
                //         );
                //         dataPoint.displayStartTime = moment(dataPoint.startDate).format(
                //           `LT`
                //         );
                //         dataPoint.displayEndDate = moment(dataPoint.endDate).format(`ll`);
                //         if (dataPoint.valueA > 0) {
                //           allDataPointsHaveNegativeValues = false;
                //           allDataPointsHaveNullValue = false;
                //         } else if (dataPoint.valueA < 0) {
                //           allDataPointsHavePositiveValues = false;
                //           allDataPointsHaveNullValue = false;
                //         }
                //       });
                //     }
                //   });
                // }
                // this.context = canvas.getContext("2d");
                // const dataset = this.data.datasets.find(
                //   (d) => d.id === "t-csr-weekly-variation"
                // );
                // if (!dataset) return;
                // const parsedData = dataset.data.map((d) => {
                //   const isPositiveValue = d.valueA > 0;
                //   let backgroundColor = "";
                //   let borderColor = "";
                //   if (isPositiveValue) {
                //     backgroundColor = "rgba(0,255,0,0.5)";
                //     // borderColor = "rgba(0,255,0,0.5)";
                //   } else {
                //     backgroundColor = "rgba(255,0,0,0.5)";
                //     // borderColor = "rgba(255,0,0,0.5)";
                //   }
                //   borderColor = backgroundColor;
                //   return {
                //     x: d.x.replace(",", "."),
                //     y: d.y,
                //     valueA: d.valueA,
                //     valueB: d.valueB,
                //     valueC: d.valueC,
                //     label: d.label,
                //     backgroundColor: backgroundColor,
                //     borderColor: borderColor,
                //     startDate: d.startDate,
                //     endDate: d.endDate,
                //     userId: d.userId,
                //     entityBaseId: d.entityBaseId,
                //     gameId: d.gameId,
                //     opponentEntityBaseId: d.opponentEntityBaseId,
                //     opponentName: d.opponentName,
                //     opponentImageUrl: d.opponentImageUrl,
                //     displayStartDate: d.displayStartDate,
                //     displayEndDate: d.displayEndDate,
                //     displayStartTime: d.displayStartTime,
                //   };
                // });
                const canvasId = canvas.id;
                canvas.style.display = "none";
                if (!this.data.datasets || this.data.datasets.length === 0) {
                    return;
                }
                const datapoints = this.data.datasets[0].data;
                if (!datapoints || datapoints.length === 0) {
                    return;
                }
                const parsedData = datapoints.map((d) => {
                    const isPositiveValue = d.valueA > 0;
                    let backgroundColor = "";
                    let borderColor = "";
                    if (isPositiveValue) {
                        backgroundColor = "rgba(0,255,0,0.5)";
                    }
                    else {
                        backgroundColor = "rgba(255,0,0,0.5)";
                    }
                    borderColor = backgroundColor;
                    return {
                        x: d.x.replace(",", "."),
                        y: d.y,
                        valueA: d.valueA,
                        valueB: d.valueB,
                        valueC: d.valueC,
                        label: d.label,
                        backgroundColor: backgroundColor,
                        borderColor: borderColor,
                        startDate: d.startDate,
                        endDate: d.endDate,
                        userId: d.userId,
                        entityBaseId: d.entityBaseId,
                        gameId: d.gameId,
                        opponentEntityBaseId: d.opponentEntityBaseId,
                        opponentName: d.opponentName,
                        opponentImageUrl: d.opponentImageUrl,
                    };
                });
                const colors = [
                    CS.Helper.DataVisualizationHelper.MUI_PALETTE.green["500"],
                    CS.Helper.DataVisualizationHelper.MUI_PALETTE.red["500"],
                ];
                const maxX = Math.max(...parsedData.map((d) => d.valueA));
                const minX = Math.min(...parsedData.map((d) => d.valueA));
                const absoluteMaxX = Math.max(Math.abs(maxX), Math.abs(minX));
                const parsedDatapoints = parsedData.map((d, index) => {
                    var _a;
                    const id = `datapoint-${index}`;
                    const value = d.valueA;
                    const roundedValue = Math.round(value * 10) / 10;
                    const secondaryValue = d.valueB;
                    let label = d.label;
                    const parts = d.startDate.split(" ");
                    const labelSuffix = parts.length > 1 ? (_a = d.startDate.split(" ")[1]) !== null && _a !== void 0 ? _a : "" : "";
                    if (!CS.Helper.isNullOrWhiteSpace(labelSuffix)) {
                        label = CS.Helper.formatString(JSRess.XAtY, label, labelSuffix);
                    }
                    const datapoint = {
                        id: id,
                        value: roundedValue,
                        secondaryValue: secondaryValue,
                        label: label.trim(),
                    };
                    return Object.assign(Object.assign({}, datapoint), { startDate: d.startDate, opponentEntityBaseId: d.opponentEntityBaseId, opponentName: d.opponentName, opponentImageUrl: d.opponentImageUrl, endDate: d.endDate, gamesPlayed: d.valueC, tCSR: d.valueB, legacyDatapoint: d });
                });
                const groups = parsedDatapoints.reduce((acc, datapoint) => {
                    const lastGroup = acc[acc.length - 1];
                    const lastGroupHasSameOpponentEntityBaseId = lastGroup &&
                        lastGroup.length > 0 &&
                        (lastGroup[0].opponentEntityBaseId ===
                            datapoint.opponentEntityBaseId ||
                            lastGroup[0].startDate === datapoint.startDate);
                    if (lastGroupHasSameOpponentEntityBaseId) {
                        lastGroup.push(datapoint);
                    }
                    else {
                        acc.push([datapoint]);
                    }
                    return acc;
                }, []);
                if (!groups || groups.length === 0) {
                    return;
                }
                const $opponents = this.$Control.find(".csr-details-week-details-drawer-opponent-image");
                let index = 0;
                groups.forEach((group, groupIndex) => {
                    const newChartId = `${canvasId}-chartv2-${groupIndex}`;
                    const $newChartContainer = $(`<div id="${newChartId}" style="margin-top: 16px;" class="t-csr-variation-by-game-datapoints-group">
            <div class="t-csr-variation-by-game-datapoints-group__header"></div>
            <div class="t-csr-variation-by-game-datapoints-group__body"></div>
          </div>`).insertBefore(canvas);
                    const $newChartContainerBody = $newChartContainer.find(".t-csr-variation-by-game-datapoints-group__body");
                    const groupDatapoints = group;
                    const firstDatapoint = groupDatapoints[0];
                    groupDatapoints.forEach((d, datapointIndex) => {
                        const containerId = `${newChartId}-opponent-${firstDatapoint.opponentEntityBaseId}-${groupIndex}-${d.id}`;
                        const serializedLegacyDatapoint = JSON.stringify(d.legacyDatapoint);
                        let csrHtml = "";
                        let avatarHtml = "";
                        let dateHtml = "";
                        const $opponentImages = $(`.csr-details-week-details-drawer-opponent-image`);
                        const $opponentImage = $($opponentImages[index]);
                        if ($opponentImage.length > 0) {
                            avatarHtml = $opponentImage.find(".avatar")[0].outerHTML;
                            if ($opponentImage.find(".csr").length > 0)
                                csrHtml = $opponentImage.find(".csr")[0].outerHTML;
                            dateHtml = $opponentImage.find(".inner-content.date").text();
                        }
                        const $newChartItem = $(`<div id="${containerId}-datapoint-container" class="csr-datapoint hoverable" data-datapoint='${serializedLegacyDatapoint}'>
              <div class="csr-datapoint-header"> 
                <div class="opponent">
                  <div class="opponent-image"> 
                    ${avatarHtml}
                  </div>

                  <div class="opponent-info">
                    <div class="opponent-name">
                      VS ${d.opponentName}
                    </div>
                    <div class="opponent-csr">
                      ${csrHtml}
                    </div>
                  </div>
                </div>
                <div class="date">
                  ${dateHtml}
                </div>
              </div>
              <div id="${containerId}" class="csr-datapoint-body"></div>
            </div>`).appendTo($newChartContainerBody);
                        $newChartItem.offon(`click.CSRDetailsChartSetCustomElementClick2-${this.ControlId}`, (e) => {
                            const opponentPickerOverridableUrl = $(".CSRateDetailsSectionOpponentPickerOverridableUrl").val();
                            if (opponentPickerOverridableUrl) {
                                // In the url, replace "-999999" by the opponentEntityBaseId
                                const url = opponentPickerOverridableUrl.replace("-999999", d.opponentEntityBaseId);
                                CS.Nav.Go(url);
                            }
                            //const dataPoint = JSON.parse(
                            //  $(e.currentTarget).attr("data-data-point")
                            //);
                            // TODO: Trigger click on item $(".game[data-game-id='dataPoint.gameId']")
                        });
                        const divergingBarChart = new CS.Controls.DivergingBarChart({
                            colors: colors,
                            containerElementId: containerId,
                            datapoints: [d],
                            absoluteMaxX: absoluteMaxX,
                        });
                        divergingBarChart
                            .init()
                            .then(() => {
                            // console.log("divergingBarChart initialized" + containerId);
                        })
                            .catch((error) => {
                            console.log("divergingBarChart initialization failed", error);
                        });
                        index++;
                    });
                });
            }
            setCustomElements() {
                CS.Lag(`CSRDetailsChartWeeklySetCustomElements-${this.ControlId}`, 150, () => {
                    const $opponents = this.$Control.find(".csr-details-week-details-drawer-opponent-image");
                    if (!this.chart || !this.context)
                        return;
                    const dataset = this.data.datasets.find((d) => d.id === "t-csr-weekly-variation");
                    const chartDomRect = this.context.canvas.getBoundingClientRect();
                    const { scales } = this.chart;
                    const yTicks = scales.y.ticks;
                    const $canvasContainer = $(this.context.canvas).closest(".canvas-container");
                    this.chart.update();
                    let pixelForValue = 0;
                    let tickHeight = 0;
                    let imageWidth = 16;
                    const chartWidth = chartDomRect.width;
                    // const chartLeft = chartDomRect.left;
                    // const areaWidth = this.chart.chartArea.width;
                    const areaLeft = this.chart.chartArea.left;
                    const ticksWidth = areaLeft - 8;
                    dataset.data.forEach((dataPoint, index) => {
                        let $customElement = $canvasContainer.find(`.custom-element-${index}`);
                        if (!$customElement.length) {
                            $canvasContainer.append(`<div class="custom-element custom-element-${index}" data-data-point='${JSON.stringify(dataPoint)}' data-custom-element-index="${index}" data-entity-base-id="${dataPoint.opponentEntityBaseId}"></div>`);
                            $customElement = $canvasContainer.find(`.custom-element-${index}`);
                        }
                        if (!$customElement.length)
                            return;
                        if (index == 0) {
                            pixelForValue = scales.y.getPixelForValue(index);
                            tickHeight = scales.y.getPixelForValue(index + 1) - pixelForValue;
                            imageWidth = tickHeight - 8;
                            if (imageWidth > 24) {
                                imageWidth = 24;
                            }
                        }
                        else {
                            pixelForValue += tickHeight;
                        }
                        const linearGradientCssValue = `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.05) 50%, rgba(255,255,255,0) 100%)`;
                        $customElement.css({
                            position: "absolute",
                            top: `${pixelForValue}px`,
                            left: `${0}px`,
                            width: `${chartWidth}px`,
                            height: `${tickHeight}px`,
                            background: index % 2 == 0 ? linearGradientCssValue : "transparent",
                            transform: `translateY(-${tickHeight / 2}px)`,
                            "z-index": "2",
                            // pointerEvents: "none",
                        });
                        $customElement.addClass("hoverable");
                        $customElement.offon(`click.CSRDetailsChartSetCustomElementClick2-${this.ControlId}`, (e) => {
                            const opponentPickerOverridableUrl = $(".CSRateDetailsSectionOpponentPickerOverridableUrl").val();
                            if (opponentPickerOverridableUrl) {
                                // In the url, replace "-999999" by the opponentEntityBaseId
                                const url = opponentPickerOverridableUrl.replace("-999999", dataPoint.opponentEntityBaseId);
                                CS.Nav.Go(url);
                            }
                            //const dataPoint = JSON.parse(
                            //  $(e.currentTarget).attr("data-data-point")
                            //);
                            // TODO: Trigger click on item $(".game[data-game-id='dataPoint.gameId']")
                        });
                        if (!$opponents.length) {
                            return;
                        }
                        const correspondingOpponent = $opponents[index];
                        const $correspondingOpponent = $(correspondingOpponent);
                        const $avatar = $correspondingOpponent.find(".avatar");
                        const $info = $correspondingOpponent.find(".info");
                        $correspondingOpponent.css({
                            position: "absolute",
                            top: `${pixelForValue}px`,
                            left: `${0}px`,
                            width: `100%`,
                            // width: `${ticksWidth}px`,
                            //height: `${imageWidth}px`,
                            //transform: `translateY(-${imageWidth / 2}px)`,
                            transform: `translateY(-50%)`,
                            display: "block",
                        });
                        $avatar.css({
                            width: `${imageWidth}px`,
                            height: `${imageWidth}px`,
                            "flex-shrink": "0",
                        });
                    });
                });
            }
            OnDispose() {
                console.log("CSRWeekDetailsPopup disposing");
                CS.DOM.$win.off("resize.CSRDetailsSectionWeeklyChart2", () => {
                    this.setCustomElements();
                });
                if (this.chart) {
                    this.chart.destroy();
                    this.chart = null;
                }
                this.context = null;
                this.data = null;
                console.log("CSRWeekDetailsPopup disposed");
            }
        }
        Controls.CSRWeekDetailsPopup = CSRWeekDetailsPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=csr-week-details-popup-control.js.map
